
<div class="edp-card-widget card d-flex flex-space-around cursor-pointer" (click)="clickAction()">
    <div class="card-header">
        <span class="card-title">{{ 'pt.edp.edponline.widget.requests.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-Bop-017" aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-body pt-0">
        <div class="detail-info" *ngIf="!(countRequests > 1)">
            <span class="detail-info-title d-inline-block">
                {{ contactInfo.Service | translate }}:
            </span>
            <span class="detail-info-motive d-block font-weight-500">
                {{ contactInfo.Motive | translate }}
            </span>
            <span class="detail-info-id d-none d-wdgt-block pt-2">
                {{ 'pt.edp.edponline.widget.requests.details.number' | translate }} #{{ contactInfo.ID }}
            </span>
        </div>
        <div class="detail-info" *ngIf="(countRequests > 1)">
            <span class="detail-info-title d-block"
                [innerHTML]="'pt.edp.edponline.widget.requests.details.multiple' | translate: {countRequests: countRequests}"></span>
        </div>
    </div>
    <div class="card-footer d-flex align-items-wdgt-center">
        <ng-container *ngIf="!(countRequests > 1)">
            <span [ngClass]="contactInfo.colorClass">
                <i class="detail-icon" [ngClass]="contactInfo.iconClass"></i>
            </span>
            <div class="detail-footer align-self-center ml-2">
                <span class="detail-footer-status font-weight-500"
                    [ngClass]="contactInfo.colorClass">{{ contactInfo.Status | translate }}</span>
                <span class="detail-footer-description ml-1"
                    [innerHTML]="statusDescription"></span>
            </div>
        </ng-container>
        <ng-container *ngIf="(countRequests > 1)">
            <span class="awaiting-title">
                <i class="detail-icon icon-edponline-Bop-132"></i>
            </span>
            <div class="detail-footer align-self-center ml-2">
                <span class="detail-footer-status font-weight-500 awaiting-title">
                    {{ 'pt.edp.edponline.widget.requests.status.analysis' | translate }}</span>
                <span class="detail-footer-description ml-1"
                    [innerHTML]="statusDescription"></span>
            </div>
        </ng-container>
    </div>
</div>